import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/Home';
import AuthForm from './components/LoginRegister';
import VerifyEmail from './components/VerifyEmail';
import './App.css';

const APP_URL = process.env.REACT_APP_CHATBOT_URL || "http://localhost:3000";

function RedirectIfLoggedIn() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    // Clear talktokam.com localStorage when user logs out from the app
    if (params.get("logged_out") === "1") {
      localStorage.clear();
      window.history.replaceState(null, "", "/");
      return;
    }

    // Don't redirect on auth pages
    if (["/login", "/signup", "/verify-email"].includes(location.pathname)) return;

    const stored = localStorage.getItem("user");
    if (stored && stored !== "undefined") {
      try {
        const u = JSON.parse(stored);
        if (u.token) {
          const params = new URLSearchParams({
            token: u.token, userId: u._id || '', role: u.role || '',
            name: u.fullName || '', email: u.email || '', plan: u.plan || '',
          });
          window.location.href = `${APP_URL}/auth/callback?${params.toString()}`;
          return;
        }
      } catch (_) {}
      const redirectTo = `${APP_URL}/app/dashboard`;
      window.location.href = redirectTo;
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <>
      <RedirectIfLoggedIn />
      <Routes>
        <Route index element={<HomePage />} />
        <Route path="login" element={<AuthForm />} />
        <Route path="signup" element={<AuthForm />} />
        <Route path="verify-email" element={<VerifyEmail />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </>
  );
}

export default App;
